import {
	FISERV_ALWAYS_CARRIER_CODES,
	FISERV_EXCEPT_VISA_CALL_CARRIER_CODES,
	GDS_ONLY_CARRIER_CODES,
	NO_CARD_CARRIER_CODES,
} from '../constants/authorizationChannels';
import { MERCHANT_NUMBER_RULES, MerchantNumberRule } from '../constants/merchantNumbers';

export type CarrierChannelSummaryType = 'no_cards' | 'gds' | 'fiserv_always' | 'fiserv_except_visa' | 'unknown';

/** Una aerolínea de "Códigos de comercio y cuotas": de la tabla fija o de las reglas de la base (`merchantRules`). */
export interface CarrierReferenceItem {
	code: string;
	name: string;
	rules: MerchantNumberRule[];
	summaryType: CarrierChannelSummaryType;
}

export const getCarriersFromMerchantRules = (): CarrierReferenceItem[] => {
	const byCode = new Map<string, string>();

	MERCHANT_NUMBER_RULES.forEach((rule) => {
		if (!byCode.has(rule.carrierCode)) {
			byCode.set(rule.carrierCode, rule.carrierName);
		}
	});

	return Array.from(byCode.entries())
		.map(([code, name]) => ({
			code,
			name,
			rules: getRulesForCarrier(code),
			summaryType: getCarrierChannelSummaryType(code),
		}))
		.sort((a, b) => a.name.localeCompare(b.name, 'es'));
};

export const getRulesForCarrier = (carrierCode: string): MerchantNumberRule[] =>
	MERCHANT_NUMBER_RULES.filter((rule) => rule.carrierCode === carrierCode.toUpperCase());

export const getCarrierChannelSummaryType = (carrierCode: string): CarrierChannelSummaryType => {
	const code = carrierCode.toUpperCase();

	if (NO_CARD_CARRIER_CODES.includes(code as (typeof NO_CARD_CARRIER_CODES)[number])) {
		return 'no_cards';
	}

	if (GDS_ONLY_CARRIER_CODES.includes(code as (typeof GDS_ONLY_CARRIER_CODES)[number])) {
		return 'gds';
	}

	if (FISERV_ALWAYS_CARRIER_CODES.includes(code as (typeof FISERV_ALWAYS_CARRIER_CODES)[number])) {
		return 'fiserv_always';
	}

	if (FISERV_EXCEPT_VISA_CALL_CARRIER_CODES.includes(code as (typeof FISERV_EXCEPT_VISA_CALL_CARRIER_CODES)[number])) {
		return 'fiserv_except_visa';
	}

	return 'unknown';
};
